import {BriefcaseRegularIcon} from 'shells/icon/svg/briefcase-regular-icon';
import {DropdownSelectInline} from 'shells/select-inline/dropdown-select-inline';

import {useGetAccountTypes} from '../../../core/select/hooks/use-get-account-types';

import {appHistory} from '../../../../history';

import {EditFieldWrapper} from '../../shared/header/edit-fields/edit-field-wrapper';

interface Props {
    accountTypeId: string | null;
    onUpdateAccountType: (accountTypeId: string, accountTypeName: string) => void;
    canAccessSetup: boolean;
}

export function AccountTypeField(props: Props) {
    const {accountTypes} = useGetAccountTypes();

    const selectedAccountType = props.accountTypeId
        ? accountTypes.find((type) => type.id === props.accountTypeId)
        : undefined;

    return (
        <EditFieldWrapper
            icon={BriefcaseRegularIcon}
            label='Company type'
            children={
                <DropdownSelectInline
                    options={accountTypes}
                    selectedValue={selectedAccountType}
                    onChange={(selected) => {
                        if (selected) {
                            props.onUpdateAccountType(selected.id, selected.name);
                        }
                    }}
                    isDisabled={!props.accountTypeId}
                    footerButton={
                        props.canAccessSetup && {
                            label: 'Manage company types',
                            onClick: () => {
                                appHistory.push('/setup/company-type');
                            },
                        }
                    }
                />
            }
        />
    );
}
